'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import Content from './Content';
import { formatDateForProduct } from './utils';
import { ScrollProvider } from '@/context/ScrollProvider';
import { VisibleVersionProvider } from '@/context/VisibleVersionProvider';
import BreadcrumbsWrap from '@/ui/components/BreadcrumbsWrap';
import ContentHeader from '@/ui/components/ContentHeader';

interface ChangelogProps {
  product: Product;
  totalPages: number;
  downloads: DownloadItem[];
  locale: string;
  slug: string;
  infoDataArray: InfoData;
}

export default function Changelog({
  product,
  totalPages,
  downloads,
  locale,
  slug,
  infoDataArray,
}: ChangelogProps) {
  const t = useTranslations();

  return (
    <>
      <BreadcrumbsWrap
        items={[product, { name: t('changelog-contentType') }]}
      />

      <ContentHeader
        title={`${product.content} ${t('changelog-contentType')}`}
        tags={[slug]}
        date={formatDateForProduct(downloads[0].meta.release_date)}
        translations={Object.fromEntries(
          infoDataArray.lngs.map(lang => [lang, { slug: slug }])
        )}
        translationsBasePath="changelog/"
        translationsType="changelog"
        products={infoDataArray?.products}
      />

      <ScrollProvider>
        <VisibleVersionProvider>
          <Content
            loadAll={totalPages > 1}
            versions={downloads}
            locale={locale}
            slug={slug}
          />
        </VisibleVersionProvider>
      </ScrollProvider>
    </>
  );
}
